import { render, staticRenderFns } from "./cumplimentacion-rapida.vue?vue&type=template&id=30e06b4d&"
import script from "./cumplimentacion-rapida.vue?vue&type=script&lang=js&"
export * from "./cumplimentacion-rapida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports